
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContextMessageAcceptedSolutionButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MessageId"},"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AcceptedSolutionMessage"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"solution"},"arguments":[],"directives":[]}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContextMessageConversation"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContextMessageBoard"},"directives":[]}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("../messages/MessageId.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ContextMessageConversation.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ContextMessageBoard.fragment.graphql").definitions));


    module.exports = doc
  
